import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface CheckedInTrailerTypeOverrideDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirms a user override of the trailer-type inherited from a checked-in
 * trailer. Confirming records intent; the actual write to the trailers row
 * happens on order submit so it can be aborted with the rest of the form.
 */
export function CheckedInTrailerTypeOverrideDialog({
  open,
  onConfirm,
  onCancel,
}: CheckedInTrailerTypeOverrideDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>You are modifying a checked-in trailer</AlertDialogTitle>
          <AlertDialogDescription>
            This will update the check-in record. Are you sure you want to proceed?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Yes, update it</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}